import { useMutation } from '@tanstack/react-query';

import { Axios } from '@app/web-components';

const RESOURCE_URL = '/dms-tickets';

export const useStartPullDmsTickets = () => {
  const axios = Axios.useAxiosApi();

  return useMutation({
    mutationFn: async () => axios.post(`${RESOURCE_URL}/start-pull-dms-tickets`),
  });
};
